import { Product, VariantGroup, Variant } from "@/types/types";
import {
  OFFERTYPE_REDUCED,
  OFFERTYPE_PROMOTION,
  OFFERTYPESUMMARY_REDUCED,
  OFFERTYPESUMMARY_PROMOTION,
  OFFERTYPESUMMARY_SELECTED_REDUCED,
  OFFERTYPESUMMARY_SELECTED_PROMOTION,
} from "@/constants/constants";
import { isPromotionalMessage } from "@/utils/product/getPromoMessaging.ts";

export type MatchStatus = "all" | "some" | "none";

const isVariantReducedToClear = (variant: Variant): boolean => {
  return variant.price && variant.price?.offerType
    ? variant.price?.offerType === OFFERTYPE_REDUCED
    : false;
};

const isVariantPromotional = (variant: Variant): boolean => {
  return variant.price && variant.price?.offerType
    ? variant.price?.offerType === OFFERTYPE_PROMOTION
    : false;
};

const hasPriceMatchedNonPriceEstablishedMessage = (
  messaging?: Variant["messaging"],
) => {
  const priceMatchNonEstablishedMessage = messaging?.find(
    (message) =>
      isPromotionalMessage(message) &&
      message.promotionType === "Price match non price established",
  );

  if (priceMatchNonEstablishedMessage) {
    return priceMatchNonEstablishedMessage.title.includes("on selected")
      ? "some"
      : "all";
  }
  return "none";
};

export const isVariantPriceMatchedNonPriceEstablished = (variant: Variant) => {
  return (
    variant.messaging?.some(
      (message) =>
        isPromotionalMessage(message) &&
        message.type === "promotional" &&
        message.promotionType === "Price match non price established",
    ) || false
  );
};

const isAllVariantsReduced = (product: Product): boolean =>
  product.variantPriceRange?.offerTypeSummary === OFFERTYPESUMMARY_REDUCED;

const isAllVariantsSave = (product: Product): boolean =>
  product.variantPriceRange?.offerTypeSummary === OFFERTYPESUMMARY_PROMOTION;

export const getProductPriceMatchNonPriceEstablishedStatus = (
  product: Product,
): MatchStatus => hasPriceMatchedNonPriceEstablishedMessage(product.messaging);

const isVariantGroupReducedFor = (
  variantGroup: VariantGroup,
  offerTypeSummary: string,
) => {
  return variantGroup?.variantPriceRange?.offerTypeSummary === offerTypeSummary;
};

const isAllVariantsReducedForColour = (variantGroup: VariantGroup): boolean =>
  isVariantGroupReducedFor(variantGroup, OFFERTYPESUMMARY_REDUCED);

const isSomeVariantsReducedForColour = (variantGroup: VariantGroup): boolean =>
  isVariantGroupReducedFor(variantGroup, OFFERTYPESUMMARY_SELECTED_REDUCED);

const isAllVariantsSaveForColour = (variantGroup: VariantGroup): boolean =>
  isVariantGroupReducedFor(variantGroup, OFFERTYPESUMMARY_PROMOTION);

const isSomeVariantsSaveForColour = (variantGroup: VariantGroup): boolean =>
  isVariantGroupReducedFor(variantGroup, OFFERTYPESUMMARY_SELECTED_PROMOTION);

export const getPriceMatchNonPriceEstablishedStatusForColour = (
  variantGroup: VariantGroup,
): MatchStatus =>
  hasPriceMatchedNonPriceEstablishedMessage(variantGroup.messaging);

export {
  isVariantReducedToClear,
  isVariantPromotional,
  isAllVariantsReduced,
  isAllVariantsSave,
  isAllVariantsReducedForColour,
  isSomeVariantsReducedForColour,
  isAllVariantsSaveForColour,
  isSomeVariantsSaveForColour,
};
